import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { widgetVersionObj } from '../../../Constants/ProductPage';
import { useRouterChangeStart } from '../../../Utils/customHooks';
import { getDeviceType, getScreenName } from '../../../Utils/helper';
import { addToCartHandler } from '../../../Utils/productAction';
import { getPriceParams } from '../../../Utils/productPageUtils';
import { CenterStylePopup, customStyles } from '../../../Utils/redirections';
import dynamic from 'next/dynamic';
import { getWebUserType } from '../../../Utils/getWebUserType';
import { fireEvent } from '../../../Utils/fireEvent';

const Modal = dynamic(() => import('react-modal'), {
  ssr: false,
});
const ChooseSizeModal = dynamic(() => import('./chooseSizeModal'), {
  ssr: false,
});

export default function SizePopup(props) {
  const {
    varientData,
    clickProductColorHandler,
    productDetail,
    selectedData,
    setAddedToCart,
    VarientSelected,
    showSizePopup,
    setShowSizePopup,
    setShowSizeChartPopup,
    setSizePopupButtons,
    sizePopupButtons,
  } = props;
  const sizePopup = useRef(null);
  const selectedDataString = localStorage.getItem('selectedVariant');
  const parsedDataString = JSON.parse(selectedDataString);
  const [showanimation, setShowAnimation] = useState(false);
  const [Styles, setStyles] = useState(
    getDeviceType() == 'mWeb'
      ? customStyles('', '', '0', '')
      : CenterStylePopup('50%', 'auto', 'auto', '50%'),
  );
  const router = useRouter();
  const viewSizeChartHandler = () => {
    setShowSizeChartPopup(true);
    setShowSizePopup(false);
  };
  const { pricing_param, conversion_param } = getPriceParams(productDetail);
  const params = new URLSearchParams(window.location.search);
  const closeModalPopup = () => {
    params.delete('sizePopup');
    setShowSizePopup(false);
    if (window?.history?.length > 2) {
      router.back();
    } else {
      router.replace(
        window.location.pathname.toString() + '?' + params,
        undefined,
        { shallow: true, scroll: false },
      );
    }
    fireEvent({
      category: 'discard_popup',
      screen_name: getScreenName(),
      id: productDetail?.nickName,
      pricing_param: pricing_param,
      conversion_param: conversion_param,
      selling_price: productDetail?.price,
      sku_nickname: productDetail?.nickName,
      sku_type: 'product',
      user_type: getWebUserType(),
      page_url: window?.location?.href,
      parent: 'select_size',
      pdp_variant:
        productDetail?.widgets[0]?.version == widgetVersionObj.aPlusPlus
          ? productDetail?.isfashionReady
            ? 'aplus_plus_fashion_ready'
            : 'aplus_plus'
          : productDetail?.isfashionReady
            ? 'aplus_fashion_ready'
            : 'aplus',
    });
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
  };
  useEffect(() => {
    if (showSizePopup) {
      params.set('sizePopup', 'true');
      router.push(window?.location?.pathname + '?' + params, undefined, {
        shallow: true,
        scroll: false,
      });
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
      fireEvent({
        category: 'viewed_popup',
        screen_name: getScreenName(),
        id: productDetail?.nickName,
        pricing_param: pricing_param,
        conversion_param: conversion_param,
        selling_price: productDetail?.price,
        sku_nickname: productDetail?.nickName,
        sku_type: 'product',
        user_type: getWebUserType(),
        page_url: window?.location?.href,
        parent: 'select_size',
        pdp_variant:
          productDetail?.widgets[0]?.version == widgetVersionObj.aPlusPlus
            ? productDetail?.isfashionReady
              ? 'aplus_plus_fashion_ready'
              : 'aplus_plus'
            : productDetail?.isfashionReady
              ? 'aplus_fashion_ready'
              : 'aplus',
      });
    } else {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    }
  }, [showSizePopup]);
  useEffect(() => {
    if (showanimation) {
      setTimeout(() => {
        setShowAnimation(false);
      }, 3000);
    }
  }, [showanimation]);

  const handleSizePopup = (url, shallow) => {
    if (!url.includes('sizePopup')) {
      setShowSizePopup(false);
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    }
  };
  useRouterChangeStart(handleSizePopup);

  const clickProduct = (url, option, selectedAttribute, type, from) => {
    if (selectedAttribute && type) {
      if (getDeviceType() == 'desktop') {
        setStyles(CenterStylePopup('50%', 'auto', 'auto', '50%'));
      } else {
        setStyles(customStyles('', '', '0', ''));
      }
      clickProductColorHandler(
        url,
        option,
        selectedAttribute,
        type,
        from == 'size_chart' ? 'size_chart' : 'select_size',
      );
      setSizePopupButtons(false);
    }
  };

  const setAddedToCarthandler = async (value) => {
    closeModalPopup();
    setAddedToCart(value);
    await addToCartHandler(parsedDataString?.productId);
  };
  const modalProps = {
    closeModalPopup,
    viewSizeChartHandler,
    showanimation,
    clickProduct,
    selectedData,
    varientData,
    productDetail,
    setAddedToCarthandler,
    showSizePopup,
    setShowAnimation,
    sizePopupButtons,
    VarientSelected,
  };
  return showSizePopup ? (
    <Modal
      isOpen={showSizePopup}
      // onRequestClose={closeModalPopup}
      style={Styles}
      appElement={sizePopup.current}
    >
      <ChooseSizeModal {...modalProps} />
    </Modal>
  ) : null;
}
